import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject, Subject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {ReceivablesImport} from "../interface/receivables-import";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {first, take} from "rxjs/operators";
import {Uuid} from "../interface/response/uuid";

@Injectable({
  providedIn: 'root'
})
export class ReceivablesImportsService {
  public readonly importListSubject: ReplaySubject<CountedAndPaginated<ReceivablesImport>>
    = new ReplaySubject<CountedAndPaginated<ReceivablesImport>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public loadImportList(page: number, pageSize: number, filters: object, subject?: Subject<CountedAndPaginated<ReceivablesImport>>): void {
    this.httpClient.get(`/rest/crm/receivables-import?page=${page + 1}&pageSize=${pageSize}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<ReceivablesImport>) => {
        if (subject) {
          subject.next(result);
        } else {
          this.importListSubject.next(result);
        }
      });
  }

  public import(formData: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/receivables-import`, formData)
      .pipe(
        take(1)
      ) as Observable<Uuid>;
  }

  public deleteImport(uuid: string): Observable<Uuid>  {
    return this.httpClient.delete(`/rest/crm/receivables-import/${uuid}`)
      .pipe(first()) as Observable<Uuid>;
  }

  public downloadImportFile(importId: string): void {
    this.document.location.href = `/rest/crm/receivables-import/${importId}/downloadFile`;
  }

  public downloadReport(filters: any): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/receivables-import/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

}
